import React, { Component } from 'react';
import { Blank as Layout } from '../components/layouts';
import { Spinner } from '../components/common';
import { detectAdBlocker } from '../utils/helpers/detect_ad_blocker';

class Initializing extends Component {
  componentDidMount() {
    detectAdBlocker();
  }
  render() {
    return (
      <Layout>
        <div className={this.props.theme || ''}>
          <div className='flex-center'>
            <div className='spinkit sk-loading'>
              <Spinner />
            </div>
            <p>Initializing...</p>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Initializing;
